import { AccountQueryKeys } from "../accounts/query-keys";
import { AddressSuggestionQueryKeys } from "../address-suggestions/query-keys";
import { AdQueryKeys } from "../ads/query-keys";
import { AiSearchKeys } from "../ai-search/query-keys";
import { AlertQueryKeys } from "../alerts/query-keys";
import { AnnouncementsQueryKeys } from "../announcements/query-keys";
import { AuthTokenQueryKeys } from "../auth-tokens/query-keys";
import { BoostQueryKeys } from "../boosts/query-keys";
import { ChatMessageQueryKeys } from "../chat-messages/query-keys";
import { ChatQueryKeys } from "../chats/query-keys";
import { DataExportsQueryKeys } from "../data-exports/query-keys";
import { EmbedQueryKeys } from "../embed/query-keys";
import { PremiumFeaturesKeys } from "../features/query-keys";
import { FeedQueryKeys } from "../feeds/query-keys";
import { GemQueryKeys } from "../gems/query-keys";
import { GroupCategoryQueryKeys } from "../group-categories/query-keys";
import { GroupMemberQueryKeys } from "../group-members/query-keys";
import { GroupRelationshipQueryKeys } from "../group-relationships/query-keys";
import { GroupTagQueryKeys } from "../group-tags/query-keys";
import { GroupQueryKeys } from "../groups/query-keys";
import { MediaQueryKeys } from "../media/query-keys";
import { OnboardingCategoriesQueryKeys } from "../onboarding-categories/query-keys";
import { PlaceholderQueryKeys } from "../placeholders/query-keys";
import { PolicyQueryKeys } from "../policies/query-keys";
import { PollQueryKeys } from "../polls/query-keys";
import {
  PredictionCategoryQueryKeys,
  PredictionQueryKeys,
} from "../predictions/query-keys";
import { RelationshipQueryKeys } from "../relationships/query-keys";
import { RulesQueryKeys } from "../rules/query-keys";
import { MfaQueryKeys } from "../sessions/query-keys";
import {
  SportsQueryKeys,
  GameQueryKeys,
  TeamQueryKeys,
  NewsQueryKeys,
} from "../sports/query-keys";
import { StatusQueryKeys } from "../statuses/query-keys";
import {
  SubscriptionPaymentQueryKeys,
  SubscriptionPlanQueryKeys,
  SubscriptionQueryKeys,
  SubscriptionPaymentCardQueryKeys,
} from "../subscriptions/query-keys";
import { SuggestionQueryKeys } from "../suggestions/query-keys";
import { TagQueryKeys } from "../tags/query-keys";
import { VideoQueryKeys } from "../video/query-keys";

enum EntityType {
  ACCOUNTS = "accounts",
  ADDRESS_SUGGESTIONS = "addressSuggestions",
  ADS = "ads",
  AI_SEARCH = "aiSearch",
  ALERTS = "alerts",
  ANNOUNCEMENTS = "announcements",
  AUTH_TOKENS = "authTokens",
  BOOSTS = "boosts",
  CHATS = "chats",
  CHAT_MESSAGES = "chatMessages",
  FEEDS = "feeds",
  GEMS = "gems",
  GROUPS = "groups",
  GROUP_CATEGORIES = "groupCategories",
  GROUP_MEMBERS = "groupMembers",
  GROUP_RELATIONSHIPS = "groupRelationships",
  GROUP_TAGS = "groupTags",
  MEDIA = "media",
  MFA = "mfa",
  ONBOARDING_CATEGORIES = "onboardingCategories",
  PLACEHOLDERS = "placeholders",
  POLLS = "polls",
  POLICIES = "policies",
  PREDICTIONS = "predictions",
  PREDICTION_CATEGORIES = "predictionCategories",
  PREMIUM_FEATURES = "premiumFeatures",
  RULES = "rules",
  RELATIONSHIPS = "relationships",
  REBLOGS = "reblogs",
  STATUSES = "statuses",
  SUBSCRIPTIONS = "subscriptions",
  SUBSCRIPTION_PAYMENT_CARDS = "subscriptionPaymentCards",
  SUBSCRIPTION_PAYMENTS = "subscriptionPayments",
  SUBSCRIPTION_PLANS = "subscriptionPlans",
  SUGGESTIONS = "suggestions",
  SPORTS = "sports",
  SPORT_GAMES = "sportGames",
  SPORT_TEAMS = "sportTeams",
  NEWS = "news",
  TAGS = "tags",
  DATA_EXPORTS = "dataExports",
  VIDEOS = "videos",
  EMBED = "embed",
}

const QueryKeys = {
  [EntityType.ACCOUNTS]: AccountQueryKeys,
  [EntityType.ADDRESS_SUGGESTIONS]: AddressSuggestionQueryKeys,
  [EntityType.ADS]: AdQueryKeys,
  [EntityType.AI_SEARCH]: AiSearchKeys,
  [EntityType.AUTH_TOKENS]: AuthTokenQueryKeys,
  [EntityType.ANNOUNCEMENTS]: AnnouncementsQueryKeys,
  [EntityType.BOOSTS]: BoostQueryKeys,
  [EntityType.CHATS]: ChatQueryKeys,
  [EntityType.CHAT_MESSAGES]: ChatMessageQueryKeys,
  [EntityType.FEEDS]: FeedQueryKeys,
  [EntityType.GEMS]: GemQueryKeys,
  [EntityType.GROUPS]: GroupQueryKeys,
  [EntityType.GROUP_CATEGORIES]: GroupCategoryQueryKeys,
  [EntityType.GROUP_MEMBERS]: GroupMemberQueryKeys,
  [EntityType.GROUP_RELATIONSHIPS]: GroupRelationshipQueryKeys,
  [EntityType.GROUP_TAGS]: GroupTagQueryKeys,
  [EntityType.MEDIA]: MediaQueryKeys,
  [EntityType.MFA]: MfaQueryKeys,
  [EntityType.ALERTS]: AlertQueryKeys,
  [EntityType.ONBOARDING_CATEGORIES]: OnboardingCategoriesQueryKeys,
  [EntityType.PLACEHOLDERS]: PlaceholderQueryKeys,
  [EntityType.POLLS]: PollQueryKeys,
  [EntityType.POLICIES]: PolicyQueryKeys,
  [EntityType.PREDICTIONS]: PredictionQueryKeys,
  [EntityType.PREDICTION_CATEGORIES]: PredictionCategoryQueryKeys,
  [EntityType.PREMIUM_FEATURES]: PremiumFeaturesKeys,
  [EntityType.RULES]: RulesQueryKeys,
  [EntityType.RELATIONSHIPS]: RelationshipQueryKeys,
  [EntityType.STATUSES]: StatusQueryKeys,
  [EntityType.SUBSCRIPTIONS]: SubscriptionQueryKeys,
  [EntityType.SUBSCRIPTION_PAYMENT_CARDS]: SubscriptionPaymentCardQueryKeys,
  [EntityType.SUBSCRIPTION_PAYMENTS]: SubscriptionPaymentQueryKeys,
  [EntityType.SUBSCRIPTION_PLANS]: SubscriptionPlanQueryKeys,
  [EntityType.SUGGESTIONS]: SuggestionQueryKeys,
  [EntityType.SPORTS]: SportsQueryKeys,
  [EntityType.SPORT_GAMES]: GameQueryKeys,
  [EntityType.SPORT_TEAMS]: TeamQueryKeys,
  [EntityType.NEWS]: NewsQueryKeys,
  [EntityType.TAGS]: TagQueryKeys,
  [EntityType.DATA_EXPORTS]: DataExportsQueryKeys,
  [EntityType.VIDEOS]: VideoQueryKeys,
  [EntityType.EMBED]: EmbedQueryKeys,
};

export { QueryKeys, EntityType };
